import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import userActions from '../user/userActions';

import { Page } from '../components/common';
import { SectionRight } from '../components/sections';
import HomePageAssessment from '../landing/HomePageAssessment';

interface Props {
	user: UserDetails;
	referrerName: string;
	actions: any;
	history: any;
	match: any;
}
class SpousalReferralLinkPage extends React.Component<Props> {
	componentDidMount() {
		const spousalReferralCode = this.props.match.params.spousalReferralCode;
		this.props.actions.fetchReferrerNameBySpousalReferralCode(spousalReferralCode)
			.then(() => {
				if (this.props.referrerName === '') {
					// if the referral code was invalid, redirect to home page
					this.props.history.replace('/');
				} 
				else {
					this.props.actions.setReferralCode(spousalReferralCode);
				}
			});
	}

	render() {
		return (
			<Page title="">
				<header className="page-hero page-hero-lg">
					<div className="page-hero-content">
						<div className="container">
							<div className="row">
								<div className="col-md-5 text-light d-flex flex-column justify-content-center">
									<h1 className="page-hero-title page-title-display">
										Welcome
									</h1>
									<p className="mb-0 lead max-read-width">
										<strong>{this.props.referrerName}</strong> has invited you to join Mosaic Life.
										Sign up today and you and <strong>{this.props.referrerName}</strong> will 
										each receive a <strong>$120</strong> credit after your first month.
									</p>
								</div>
								<div className="col-md-6 offset-md-1 mt-5 mt-md-0 pl-0 d-flex flex-column justify-content-center">
									<SectionRight columns={12}>
										<HomePageAssessment />
									</SectionRight>
								</div>
							</div>
						</div>
					</div>
				</header>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		user: state.user.user,
		referrerName: state.user.referrerName
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpousalReferralLinkPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/SpousalReferralLinkPage.tsx